<body class="body-form-signin login-bg"
  [style]="whitelabel ? 'background-image: url(' + whitelabelURL + whitelabel + '/login.webp);' : ''">
  <main class="form-register">
    <form class="form-shadow p-4">
      <div class="container justify-content-center">
        <div class="row justify-content-center">
          <div class="text-center">
            <a href="https://cubos.com" target="_blank"> <img class="mb-4" src="assets/images/cubos_cube_rgb.svg" alt="" width="72" height="57"> </a>
            
            <div class="col-md-12 col mb-2" *ngIf="!isConfirmed">
              <h3 class="mt-md-1 ml-md-0 ml-4 text-center" i18n="@@confirmActivateAutocharge">Nur noch ein Klick um Autocharge zu aktivieren!</h3>
            </div>

            <div class="col-md-12 col mb-2" *ngIf="isConfirmed && isSuccess">
              <h3 class="mt-md-1 ml-md-0 ml-4 text-center" i18n="@@activateAutochargeSuccessHeader">Sie haben Autocharge für Ihr Fahrzeug aktiviert!</h3>
              <div class="swal2-icon swal2-success swal2-icon-show" style="display: flex;">
                <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>
                <span class="swal2-success-line-tip"></span>
                <span class="swal2-success-line-long"></span>
                <div class="swal2-success-ring"></div>
                <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>
                <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div>
              </div>
            </div>

            <div class="col-md-12 col mb-2" *ngIf="isConfirmed && !isSuccess">
              <h3 class="mt-md-1 ml-md-0 ml-4 text-center">Der Link ist abgelaufen!</h3>
              <div class="swal2-icon swal2-error swal2-icon-show" style="display: flex;  margin-bottom: 2em;">
                <span class="swal2-x-mark">
                  <span class="swal2-x-mark-line-left"></span>
                  <span class="swal2-x-mark-line-right"></span>
                </span>
              </div>
              <span>
                Um dennoch Autocharge für Ihr Fahrzeug zu aktivieren, kontaktieren Sie bitte die Verwaltung der Ladeinfrastruktur.
                Die dafür benötigte Fahrzeug-ID finden Sie oben rechts in Ihrer E-Mail.
              </span>
            </div>

          </div>
        </div>
      </div>

      <div class="row justify-content-center round">
        <div class="col-lg-10 col-md-12">
          <div class="form-group">
            <div class="row justify-content-center">
              <div class="col-md-12 col-lg-10 col-12">
                <div class="mb-1 text-center">
                  <br />
                  <button *ngIf="!isConfirmed" (click)="claimRfidCard()" id="confirm" class="btn btn-yellow px-4" i18n="@activateAutochargeButton">Autocharge aktivieren</button>
                  <button *ngIf="isConfirmed" [routerLink]="['/auth/login']" id="tologin" class="w-50 btn btn-yellow" i18n="@@ToLoginButton">Zur Anmeldung</button>
                </div>
                <p class="mt-2 mb-3 text-center text-muted"><a href="https://www.cubos.com" target="_blank" style="text-decoration: none; color: #6c757d;">© {{currentYearLong()}} CUBOS Service GmbH</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </main>
</body>

<!-- <div *ngIf="isConfirmed && isSuccess == null" class="loading-spinner-container">
  <div class="spinner-border text-primary loading-spinner-lg" role="status">
    <span class="visually-hidden-focusable">Loading...</span>
  </div>
</div> -->
